import * as React from 'react';
import { Card } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import { getLegalQuestions, submitLegalQuestions } from '../../../actions/salesActions';
import './LegalStuff.css';
import { AdminJudgementQuestion, AdminJudgementQuestionResponse } from '../../../interfaces/Legal/legalInterfaces';
import LegalSection from './LegalSection';

class LegalQuestions extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            idNumber: this.props.profile.idNumber,
            idRegex: true,
            concent: false,
            nextDisabled: true,
            loggedIn: this.props.auth.uid ? true : false
        }
        this.handleClick = this.handleClick.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
    }

    async checkSubmit() {

    }

    handleClick() {
        this.props.dispatchSubmitLegalQuestions()
    }

    async componentDidMount() {
        if (this.props.sales.adminJudgementQuestions.length === 0) {
            await this.props.dispatchGetLegalQuestions()
        }
    }

    public render() {

        const questionsList: AdminJudgementQuestionResponse = { adminJudgementQuestions: this.props.sales.adminJudgementQuestions as AdminJudgementQuestion[] };
       
        let questions = questionsList.adminJudgementQuestions.map((item) => {
            if (item.text !== "") {
                return <LegalSection question={item} />
            }
        });

        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                <div className="container mt-40px">
                    <div className="row ml-0px d-block d-md-none d-lg-none acceptButton">
                        <button className="IAcceptMobile btn btn-solid-green col-12" disabled={this.props.sales.validationErrorLegalQuestions} onClick={this.handleClick}>Continue</button>
                    </div>
                    <Card className="content-box-padding-20px-with-box-shadow legalQuestion">
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <h3 className="Almost-done mb-9px">Almost done</h3>
                                <p className="text-center font-weight-500 line-height-normal mb-0px"><span className="please-note-bold">Please note:</span> In the next questions, when we say ‘you’ we mean you, any company you’ve been involved in, and all the people you intend on covering under this policy. It’s very important that you answer truthfully as this will influence the acceptance of our policy and premium.</p>
                                <hr className="modal-banking-hr-2px mt-15px mb-15px" />
                            </div>
                            <div className="row noma">
                                {questions}
                            </div>
                        </div>
                        <div className="row noma text-left">
                            <div className="col-12 nopa">
                                <p className="mb-0px"><b>Remember</b>, if any of this info changes, it’s your responsibility to let us know.</p>
                                <hr className="mt-15px mb-0px legalsection-hr-2px" />
                            </div>
                        </div>
                        <div className="row justify-content-center mt-31px d-none d-md-block d-lg-block modalAcceptButton">
                            <div className="col-12">
                                <div className="text-center">
                                    <button className="btn btn-solid-green " id="IAccept" disabled={this.props.sales.validationErrorLegalQuestions} onClick={this.handleClick}>Continue</button>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchGetLegalQuestions: () => dispatch(getLegalQuestions()),
        dispatchSubmitLegalQuestions: () => dispatch(submitLegalQuestions()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LegalQuestions);